import { RouteComponentProps } from "react-router-dom";
import { SkinStoreType } from '../loginPool/skinStore';
import { mThirdBindStoreType } from "../thirdBind/store";
import { MainStoreType } from "../loginPool/store";
import { AnyObj } from "@weapp/ui";
import { ReactNode } from "react";

export interface MInputPrefixType {
  // key: string,
  [key: string]: ReactNode | undefined,
}

export interface loginParamsType {
  password: string;
  username: string;
  tenantKey?: string;
  passportCusLoginPath?: string //自定义路径
  passportCusLoginDomain?: string //域名
  loginHardwareId?: string
  loginLanguage?: string
  loginDeviceSysVersion?: string
  loginDeviceVersion?: string
}
export interface MLoginStoreType {
  loginLoading: boolean;
  safeAccountLogin: any;
  getLogin: (value: any, callback?: any) => void;
  dialogadviceVisible: boolean;
  changeDialogadviceVisible: () => void;
  bindAdvice: (param: any) => void;
  adviceThirdBind: (param: any) => void;
  getQueryString: (param: any) => void;
  init: (ev: any) => void;
  checkVerifyCodeShow: (params: any, callback: any) => any;
  currentAssistWay: string
  qysFrameSrc: string,
  appThirdSignLogin: (data: any) => void;
  appThirdOpenLogin: (data: any) => void;
  updateLoginLoading: (loading: boolean) => void;
  getSafeAccount: (data: any) => void;
  phoneNumberOneKeyLogin: (data: any, needBindDeviceCallback: Function, bindDeviceCallback?: Function, beforeChangeBindAccount?: Function) => void;
  onKeyLoginBindAccount: (loginParmas: loginParamsType, onSuccess?: Function) => void;
  loadOneKeyLoginConfig: () => void;
  oneKeyLoginConfig: OneKeyLoginConfig;
  bindMobileToken: string;
  queryLogo: () => void
  cancelBindAccount: () => void
}

export interface MLoginStore extends RouteComponentProps {
  mLoginStore?: MLoginStoreType;
}

export interface thirdParm {
  nickname: string;
  openId: string;
  thirdType: string;
  version: string;
  secondImei: string;
  imei: string;
}
export interface MLoginProps extends RouteComponentProps {
  mLoginStore?: MLoginStoreType;
  mSkinStore: SkinStoreType;
  mThirdBindStore?: mThirdBindStoreType;
  mMainStore?: MainStoreType;
  source?: string;
  config?: any;
  customPrefixList?: MInputPrefixType,//input自定义前缀,根据key匹配
  customFooterRender?: ReactNode//自定义底部节点渲染
  isDesign?: boolean;
  animate?: boolean;//是否开启input动画
}

export class OneKeyLoginConfig {
  devType?: "2";
  enable?: 0;
  opentype?: "2";
  popout?: 1;
  prompt?: 1;
  yjdlai?: "";
  yjdlak?: "";
}